import { render } from "./AlertCircle.vue?vue&type=template&id=2a2453f8"
import script from "./AlertCircle.vue?vue&type=script&lang=js"
export * from "./AlertCircle.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__